import React from 'react'
import { Container } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import Integrations from './Integrations'

const SettingsPage = () => {
  const { t } = useTranslation('SettingsPage')

  return (
    <Container className="mt-3 d-flex flex-column flex-fill">
      <div className="d-flex flex-row justify-content-between">
        <h2>{t('title')}</h2>
      </div>

      <div className="d-flex flex-column">
        <Integrations />
      </div>
    </Container>
  )
}

export default SettingsPage
